module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    ref: "city",
    staticClass: "dof-city weex-ct weex-div",
    style: (_vm._px2rem(_vm.cityExtendStyle, 75)),
    attrs: {
      "weex-type": "div"
    }
  }, [_c('dof-searchbar', _vm._b({
    ref: "dof-searchbar",
    attrs: {
      "data-evt-dofSearchbarInputOnInput": "",
      "data-evt-dofSearchbarInputReturned": "",
      "data-evt-dofSearchbarCancelClicked": ""
    },
    on: {
      "dofSearchbarInputOnInput": _vm.onInput,
      "dofSearchbarInputReturned": _vm.onSubmit,
      "dofSearchbarCancelClicked": _vm.onCancel
    }
  }, 'dof-searchbar', _vm.mergeInputConfig, false)), _vm._v(" "), (_vm.showTab) ? _c('dof-tab', {
    ref: "dof-tab",
    attrs: {
      "data-evt-dofTabSwitch": ""
    },
    on: {
      "dofTabSwitch": _vm.onTabSwitch
    }
  }) : _vm._e(), _vm._v(" "), _c('dof-indexlist', {
    attrs: {
      "normal-list": _vm.normalList,
      "hot-list-config": _vm.hotListConfig,
      "nav-style": {
        top: '24px'
      },
      "height": _vm.listHeight,
      "show-index": _vm.showIndex,
      "only-show-list": !_vm.showNavHeader || _vm.onlyShowList,
      "city-location-config": _vm.currentCityLocationConfig,
      "data-evt-dofIndexlistItemClicked": ""
    },
    on: {
      "dofIndexlistItemClicked": _vm.onItemClick
    }
  }), _vm._v(" "), (_vm.showError) ? _c('dof-result', {
    attrs: {
      "type": "noGoods",
      "wrap-style": {
        top: '84px'
      },
      "show": true,
      "customSet": _vm.result
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-0d3aa3b4", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0d3aa3b4","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./packages/dof-city/index.vue
// module id = 563
// module chunks = 0 1